import { render, staticRenderFns } from "./LfControlAction.vue?vue&type=template&id=732a1858&scoped=true&lang=pug"
import script from "./LfControlAction.vue?vue&type=script&lang=js"
export * from "./LfControlAction.vue?vue&type=script&lang=js"
import style0 from "./LfControlAction.vue?vue&type=style&index=0&id=732a1858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732a1858",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
